<template>
	<div class="mt-10">
		<md-card>
			<md-card-expand>
				<md-card-actions md-alignment="space-between">
					<md-card-expand-trigger>
						<md-button class="expand-button-size"
							><strong
								>Emails <span>({{ emails.length }})</span></strong
							></md-button
						>
					</md-card-expand-trigger>
				</md-card-actions>
				<md-card-expand-content>
					<md-card-content class="comments">
						<div class="email-log">
							<div v-for="(email, index) in emails" class="email" :key="email._id">
								<span v-if="email.sentstatus == 'Sent'" style="color: green">
									{{ formatDate(email.sentAt) }}
								</span>
								<span v-if="email.sentstatus != 'Sent'" style="color: red">
									{{ formatDate(email.errorAt) }} : {{ email.sentstatus }}
								</span>
								<b>{{ email.subject }}</b> {{ email.to }}
								<span style="font-size:8px">({{ index }}) {{email._id}}</span>
							</div>
						</div>
					</md-card-content>
				</md-card-expand-content>
			</md-card-expand>
		</md-card>
	</div>
</template>
<!-- Script-->
<script>
import API from "../services/API";
import moment from "moment";

export default {
	name: "EmailLog",
	props: ["ask"],
	data() {
		return {
			api: new API(),
			emails: []
		}
	},
	created() {
		this.loadData();
	},
	methods: {
		loadData: async function () {
			await this.api.get(`asks/${this.$route.params.ask_id}/emails`).then(async emails => {
				this.emails = emails.data;
				//console.log("Emails for ask:", this.emails)
			});
		},
		formatDate(value) {
			if (!value) return ''
			const today = new Date();
			const cutoffDate = new Date(value);
			today.setHours(0, 0, 0, 0);
			cutoffDate.setHours(0, 0, 0, 0);
			if (cutoffDate.toDateString() == today.toDateString()) { // Today
				return moment(value).format('h:mma')
			} else {
				if (cutoffDate.getFullYear() == today.getFullYear()) {
					return moment(value).format('M/D h:mma')
				} else {
					return moment(value).format('M/D/YY h:mma')
				}
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/EmailLog.vue